import {useEffect, useState} from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useSelector, useDispatch} from "react-redux";
import {useHistory} from "react-router-dom";
import Button from "../../../components/button";
import LoadingSpinner from '../../../components/loading-spinner';
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Footer from "../../../components/footer";
import { 
    getAllUpdateActivity, 
    updateUpdateActivity, 
    clear_update_activity,
    UPDATE_UPDATE_ACTIVITY
} from "../../../redux/update_activity";

const UpdateActivities = (props) => {
    let history = useHistory();
    let dispatch = useDispatch();

    const _get_all_update_activity = useSelector((state) => state.update_activity_module._get_all_update_activity);
    const _update_update_activity = useSelector((state) => state.update_activity_module._update_update_activity);

    const {token} = useSelector((state) => state.users_module.login.data) || null;
    
    const [isLoading, setIsLoading] = useState(false);
    const [datas, setDatas] = useState([]);

    useEffect(() => {
        if (_get_all_update_activity && _get_all_update_activity.data && _get_all_update_activity.data.datos) {
            setDatas(_get_all_update_activity.data.datos);
        }
    }, [_get_all_update_activity]);

    useEffect(() => {
        if (_update_update_activity.status === 200) {
            dispatch(clear_update_activity(UPDATE_UPDATE_ACTIVITY));
            dispatch(getAllUpdateActivity(token));
            setIsLoading(false);
        } else if (_update_update_activity.status !== 0) {
            dispatch(clear_update_activity(UPDATE_UPDATE_ACTIVITY));
            toast.error(_update_update_activity.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_update_update_activity, dispatch, history, token]);


    return (
        <div className="app-content content">
            <div className="content-overlay"/>
            {isLoading && <LoadingSpinner/>}
            <div><ToastContainer/></div>
            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Actividades"
                            items={[{label: "Solicitud de edición", link: "/solicitud-ediciones"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className='table table-hover'>
                                        <thead>
                                            <tr>
                                                <th>Actividad</th>
                                                <th>Tienda</th>
                                                <th>Usuario</th>
                                                <th>Fecha agendada</th>
                                                <th>Estado</th>
                                                <th className="text-center">Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {datas.length > 0 &&
                                                datas.map(x => (
                                                    <tr>
                                                        <td>{x.actividad}</td>
                                                        <td>[{x.codigo_tienda}] {x.tienda}</td>
                                                        <td>{x.usuario}</td>
                                                        <td>{x.fecha_agendada}</td>
                                                        <td>{x.estado}</td>
                                                        <td className="text-center">
                                                            {x.estado === 'PENDIENTE' &&
                                                                <>
                                                                    <Button disabled={isLoading} type="button" text="Aprobar" className="btn btn-success mr-1" onChange={() => {
                                                                        setIsLoading(true);
                                                                        dispatch(updateUpdateActivity(token, x.id, {estado: 'APROBADO'}));
                                                                    }}/>
                                                                    <Button disabled={isLoading} type="button" text="Rechazar" theme="danger" onChange={() => {
                                                                        setIsLoading(true);
                                                                        dispatch(updateUpdateActivity(token, x.id, {estado: 'RECHAZADO'}));
                                                                    }}/>
                                                                </>
                                                            }
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default UpdateActivities;
